import type { TaskProgressorRequestMode } from '@urbanx/agx.activities.client';

type WorkflowSelection = { type: 'campaign' } | { type: 'contract'; contractId?: string };

export interface TaskProgressorSelection {
  agencyId?: string;
  campaignId?: string;
  workflow: WorkflowSelection;
  stage?: string;
  mode: TaskProgressorRequestMode;
}

export type TaskProgressorSelectionAction =
  | { type: 'agencySelected'; agencyId: string }
  | { type: 'campaignSelected'; campaignId: string }
  | {
      type: 'workflowSelected';
      workflow: WorkflowSelection;
    }
  | { type: 'contractSelected'; contractId: string }
  | { type: 'stageSelected'; stage: string }
  | { type: 'stageCleared' }
  | { type: 'modeSelected'; mode: TaskProgressorRequestMode };

export const createInitialTaskProgressorSelection = (
  mode: TaskProgressorRequestMode
): TaskProgressorSelection => ({ workflow: { type: 'campaign' }, mode });

export const taskProgressorSelectionReducer = (
  selection: TaskProgressorSelection,
  action: TaskProgressorSelectionAction
): TaskProgressorSelection => {
  switch (action.type) {
    case 'agencySelected':
      return {
        agencyId: action.agencyId,
        workflow: { type: 'campaign' },
        mode: selection.mode,
      };
    case 'campaignSelected':
      return {
        agencyId: selection.agencyId,
        campaignId: action.campaignId,
        workflow: { type: 'campaign' },
        mode: selection.mode,
      };
    case 'workflowSelected':
      return { ...selection, workflow: action.workflow, stage: undefined };
    case 'contractSelected':
      return {
        ...selection,
        workflow: { type: 'contract', contractId: action.contractId },
        stage: undefined,
      };
    case 'stageSelected':
      return { ...selection, stage: action.stage };
    case 'stageCleared':
      return { ...selection, stage: undefined };
    case 'modeSelected':
      if (action.mode === selection.mode) return selection;
      return { ...selection, mode: action.mode, stage: undefined };
  }
};
